import React, {useState, useEffect, useRef} from "react"
import { Div } from "atomize";
import { ReactComponent as CollectorIcon } from './../../../Assets/Icons/collection.svg';
import styled, {createGlobalStyle} from "styled-components";
import {connect} from "react-redux";
import Popover, {ArrowContainer} from "react-tiny-popover";
import ActivitiesGroup from "../ActivitiesGroup";
import theme from "../../../Theme/Theme";

const GlobalStyle = createGlobalStyle`
  .react-tiny-popover-container {
    overflow: visible !important;
  }
`;


const Wrapper = styled(Div)`
  border-radius: 8px;
  // overflow: hidden;
  padding: 0;
  height: 58px;
  align-items: center;
  justify-content: center;
  width: 58px;
  z-index: 200;
`;

const Link = styled.a`
  height: 58px;
  width: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Count = styled.div`
  background-color: #009BDF;
  position: absolute;
  top: -10px;
  right: -10px;
  border-radius: 25px;
  
  span {
    padding: 5px 10px;
    font-size: 12px;
    font-weight: 600;
    color: white;
  }
`;

const PopoverInner = styled.div`
  background-color: white;
  padding: 1rem;
  box-shadow: rgba(8,11,14,0.06) 0px 0px 10px 4px, rgba(8,11,14,0.1) 0px 20px 40px 0px;
  margin-right: 2rem;
  border-radius: 4px;
  width: 300px;
  z-index: 400;
  
  h4 {
    color: ${theme.colors.secondary};
    font-size: 18px;
    font-weight: bold;
    line-height: 28px;
  }
`;

function Collector(props) {
  const [hoverLink, setHoverLink] = useState(false);
  const [hoverPop, setHoverPop] = useState(false);
  const [prevActivitiesLength, setPrevActivitiesLength] = useState(props.collectorActivities.length);

  useEffect(() => {
    if (prevActivitiesLength === 0 && props.collectorActivities.length > 0) {
      props.action();
    }
    setPrevActivitiesLength(props.collectorActivities.length)
  },[props.collectorActivities]);

  return (
    <Wrapper
      shadow={5}
      bg="white"
      pos="fixed"
      top={{ xs: '1rem', md: '2rem' }}
      bottom={{ xs: 'unset', md: 'unset' }}
      right={{ xs: '6rem', md: '2rem' }}
      d="flex"
    >
      <GlobalStyle/>
      <Popover
        isOpen={hoverLink || hoverPop}
        position={'bottom'} // preferred position
        content={({ position, targetRect, popoverRect }) => (
          <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
            position={position}
            targetRect={targetRect}
            popoverRect={popoverRect}
            arrowColor={'white'}
            arrowSize={10}
            arrowStyle={{ pointerEvents: 'none' }}
          >
            <PopoverInner
              onMouseEnter={ () => setHoverPop(true)}
              onMouseLeave={ () => setTimeout( () => setHoverPop(false), 250 )}
            >
              <h4>{props.collectorActivities.length} activities in your collection</h4>
              { props.collectorActivities.length > 0 &&
                <ActivitiesGroup
                  activities={props.collectorActivities}
                  overflow={true}
                />
              }
            </PopoverInner>
          </ArrowContainer>
        )}
      >
        <Link
          onClick={() => props.action()}
          onMouseEnter={ () => setHoverLink(true)}
          onMouseLeave={ () => setTimeout( () => setHoverLink(false), 250 )}
          onFocus={ () => setHoverLink(true)}
          onBlur={() => setTimeout( () => setHoverLink(false), 250 )}
          tabIndex={0}
          aria-label={"Your collection"}
          role={"link"}
        >
          <CollectorIcon/>
        </Link>
        {
          props.collectorActivities.length > 0 &&
          <Count><span>{props.collectorActivities.length}</span></Count>
        }
      </Popover>
    </Wrapper>
  )
}


const mapStateToProps = state => {
  if (state === undefined) return {};
  return {
    collectorActivities: state.collectorActivities.collectorActivities
  };
};

export default connect(
  mapStateToProps,
)(Collector);
